import { render, staticRenderFns } from "./HPhero.vue?vue&type=template&id=32b4fa8d&scoped=true&"
import script from "./HPhero.vue?vue&type=script&lang=js&"
export * from "./HPhero.vue?vue&type=script&lang=js&"
import style0 from "./HPhero.vue?vue&type=style&index=0&id=32b4fa8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4fa8d",
  null
  
)

export default component.exports